import * as React from 'react'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { CallTrackingSmallIcon } from './atoms/icons/CallTrackingIcon'

type Props = {
  name: string
  synced: boolean
}

export function TidalCampaignTrackingHeader(props: Props) {
  const { name, synced } = props

  const formattedName = name.replace(/\s+/g, '')
  const syncText = synced ? 'Synced' : 'Authorize to Sync'

  return (
    <>
      <CallTrackingSmallIcon />
      <Stack textAlign="center" gap={0.5}>
        <Typography variant="h5">{formattedName}</Typography>
        <Typography variant="body1">{syncText}</Typography>
      </Stack>
    </>
  )
}
